import finances from './finances.svg';

export default function FinancesIcon() {
  return <img src={finances} alt={'finances'} width="32" height="32" />;
}
